export const ITEM_LONG_PRESS_MOVE_PX = 10
export const ITEM_LONG_PRESS_MS = 520

const BLOCKED_SELECTOR = [
  'button',
  'a',
  'input',
  'textarea',
  'select',
  '[role="menuitem"]',
  '.item-menu-trigger',
  '.item-buttons',
  '.grid-menu-trigger',
  '.item-image',
  '.product-image-lightbox',
].join(', ')

export function isItemLongPressTarget(target) {
  if (!target?.closest) return false
  if (target.closest(BLOCKED_SELECTOR)) return false
  return Boolean(target.closest('.item-card'))
}

export function pointerMovedBeyondThreshold(origin, point, threshold = ITEM_LONG_PRESS_MOVE_PX) {
  if (!origin || !point) return false
  const x = Number(point.x)
  const y = Number(point.y)
  const ox = Number(origin.x)
  const oy = Number(origin.y)
  if (![x, y, ox, oy].every(Number.isFinite)) return false
  return Math.hypot(x - ox, y - oy) > threshold
}
